import * as React from 'react';

interface Invoice {
  summary: string;
  tax: number;
  pretax_subtotal: number;
}

interface InvoiceSummaryProps {
  invoice: Invoice;
}

export const InvoiceSummary: React.FC<InvoiceSummaryProps> = ({ invoice }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div>
      <span>{invoice.summary}</span>
      {invoice.tax > 0 && (
        <span>
          {' '}
          <strong>
            ({formatCurrency(invoice.pretax_subtotal)} + {formatCurrency(invoice.tax)} tax)
          </strong>
        </span>
      )}
    </div>
  );
};
